import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isDevelopment } from '@ibk/shared-config';
export const DeveloperOnlyRoute = ({ children }) => {
    if (!isDevelopment()) {
        return _jsx(Navigate, { to: '/home', replace: true });
    }
    return _jsx(_Fragment, { children: children ?? _jsx(Outlet, {}) });
};
export default DeveloperOnlyRoute;
